/*
 * @Date: 2023-03-13 14:28:15
 * @LastEditors: puxue
 * @LastEditTime: 2024-06-05 14:41:40
 */
export default [
  {
    path: '/rent/v2/repair/list',
    name: 'repairList',
    component: () => import('@/pages/repair/list'),
    meta: { title: '房车维修', requireAuth: true },
  },
  {
    path: '/rent/v2/repair/detail',
    name: 'repairDetails',
    component: () => import('@/pages/repair/detail.vue'),
    meta: { title: '维修商详情', requireAuth: true },
  },
  {
    path: '/rent/v2/repair/detail/serviceDetail',
    name: 'serviceDetail',
    component: () => import('@/pages/repair/serviceDetail.vue'),
    meta: { title: '服务详情', requireAuth: true },
  },
  {
    path: '/rent/v2/repair/submitRepair',
    name: 'submitRepair',
    component: () => import('@/pages/repair/submitRepair.vue'),
    meta: { title: '我要维修/保养', requireAuth: true },
  },
  {
    path: '/rent/v2/repair/complain',
    name: 'repairComplain',
    component: () => import('@/pages/repair/complain.vue'),
    meta: { title: '举报', requireAuth: true },
  },
  {
    path: '/rent/v2/repair/evaluate',
    name: 'repairEvaluate',
    component: () => import('@/pages/repair/evaluate.vue'),
    meta: { title: '立即评价', requireAuth: true },
  },
  {
    path: '/rent/v2/repair/addCar',
    name: 'addCar',
    component: () => import('@/pages/repair/addCar.vue'),
    meta: { title: '新增车辆', requireAuth: true },
  },
  {
    path: '/rent/v2/repair/myGarage',
    name: 'myGarage',
    component: () => import('@/pages/repair/myGarage.vue'),
    meta: { title: '我的车库', requireAuth: true },
  },
  {
    path: '/rent/v2/repair/myCar',
    name: 'myCar',
    component: () => import('@/pages/repair/myCar.vue'),
    meta: { title: '我的车辆', requireAuth: true },
  },
]


// WEBPACK FOOTER //
// ./src/pages/repair/repair.js